import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Form, Input } from "semantic-ui-react";

import { isCarFieldMissing } from "./../../utils";

class DBBCarSection extends Component {
  renderField = (field, label, defaultText, type) => {
    const { car, hasValidationError, onChangeField, t } = this.props;
    const isNumber = type === "number";
    const isRequired = field !== "model_year";

    return (
      <Form.Field width={6} required={isRequired} error={isRequired && hasValidationError && isCarFieldMissing(car[field])}>
        <label>{t(label).message || defaultText}</label>
        <Input
          type={type}
          value={car[field] ?? ""}
          placeholder={t(label).message || defaultText}
          onChange={(_e, { value }) => onChangeField(field, isNumber ? (value === "" ? null : parseInt(value, 10)) : value)}
        />
      </Form.Field>
    );
  };

  render() {
    return (
      <div className="car-section">
        <Form.Group>
          {this.renderField("reg_nr", "license_plate", "License plate")}
          {this.renderField("vin_nr", "vin_number", "VIN number")}
          {this.renderField("mileage", "mileage", "Mileage", "number")}
        </Form.Group>
        <Form.Group>
          {this.renderField("make", "brand", "Brand")}
          {this.renderField("model", "model", "Model")}
          {this.renderField("model_year", "model_year", "Model Year", "number")}
        </Form.Group>
      </div>
    );
  }
}

export default withTranslation()(DBBCarSection);
